import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';

@Pipe({
  name: 'tituloSituacaoSolicitacao',
})
export class TituloSituacaoSolicitacaoPipe implements PipeTransform {
  transform(codSituacao: number): string {
    return NormalizerHelper.tituloSituacaoSolicitacao(codSituacao);
  }
}
